module.exports = __webpack_public_path__ + "assets/img/eb5b8683a07d5ed74aaf040b7ccdb6ae.svg";